import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, User } from 'lucide-react';
import './Login.css';
import { API_BASE_URL } from '../config';
import { useNotification } from '../context/NotificationContext';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const { notifyError, showLoading, hideLoading } = useNotification();

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!username || !password) return;

    showLoading('Signing in…');
    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      });
      const data = await response.json().catch(() => ({}));

      if (response.ok) {
        localStorage.setItem('token', data.token);
        localStorage.setItem('adminUsername', data.admin?.username || username);
        navigate('/');
      } else {
        notifyError(data.error || 'Invalid credentials');
      }
    } catch (e) {
      notifyError('Failed to reach the server. Is the backend running?');
    } finally {
      hideLoading();
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="logo-icon"><img src="../logo-NoBG.png" alt="Lingbari logo" className="login-logo" /></div>
          <h2>Welcome to Lingbari</h2>
          <p>Sign in to your admin dashboard</p>
        </div>

        <form onSubmit={handleLogin} className="login-form">
          <div className="form-group">
            <label className="label">Username</label>
            <div className="input-with-icon">
              <User size={18} className="icon" />
              <input
                type="text"
                className="input-field"
                placeholder="Enter username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
          </div>

          <div className="form-group">
            <label className="label">Password</label>
            <div className="input-with-icon">
              <Lock size={18} className="icon" />
              <input
                type="password"
                className="input-field"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          <button type="submit" className="btn btn-primary login-btn">
            Sign In
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
